import { APIAdapter } from "../../../helpers/api_helper";

const api = new APIAdapter();

  export const addBusiness = async (merchandId,data) => {
      try {
        const response = await api.create(`/developer-accounts/requests/${merchandId}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getBusinessByMarchandId = async (merchandId) => {
      try {
        const response = await api.get(`/merchants/${merchandId}/developer-accounts`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getAllDevelopers = async () => {
      try {
        const response = await api.get(`/developer-accounts`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateDeveloper = async ( accountId, data) => {
      try {
        const response = await api.put(`/developer-accounts/${accountId}/update`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteDeveloper = async (id) => {
    try {
        const response = await api.delete(`/developer-accounts/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
  };
